import { LayerViewModel } from "../../omnia"
import { IFieldsService } from "../../types"
import { Preview } from "./preview"

export function createFilter(fieldSvc: IFieldsService) {

    let visibleFields: Set<number>
    let visibleCropping: Set<number>

    update()

    const isFieldVisible = (fieldId: number) => visibleFields.has(fieldId)
    const isCroppingVisible = (croppingId: number) => visibleCropping.has(croppingId)

    return {

        update,
        apply,
        isFieldVisible,
        isCroppingVisible

    }


    function update() {

        visibleFields = new Set(
            fieldSvc.getFields(false)
                .filter(f => f.visible)
                .map(f => f.fieldId)
        )

        visibleCropping = new Set(
            fieldSvc.cropping
                .filter(c => c.visible)
                .map(c => c.croppingId)

        )

    }

    function apply(previews: Preview[], layers: LayerViewModel[]) {

        for (const p of previews) {
            p.visible = visibleFields.has(p.fieldId)
        }

        for (const l of layers) {
            l.visible = visibleCropping.has(l.croppingId)
        }

    }

}
